<template>
  <div>
    <v-server-table
      :url="table.url"
      ref="table"
      class="mt-4"
      :columns="table.columns"
      :options="table.options"
    >
      <div slot="afterFilterWrapper" class="form-group form-inline">
        <b-button
          class="ml-3"
          variant="outline-secondary"
          :to="{ name: 'AdminEmbroideryCategoriesScreen' }"
          >Gestionar categorías</b-button
        >
        <b-button
          class="ml-2"
          variant="primary"
          :to="{ name: 'AdminStandardEmbroideriesNewScreen' }"
          >Nuevo bordado</b-button
        >

        <b-button
          variant="outline-danger"
          class="ml-2"
          :disabled="table.selected.length === 0"
          @click="removeSelected()"
          >Eliminar seleccionadas</b-button
        >
      </div>

      <div slot="h__checkbox">
        <b-form-checkbox v-model="table.allSelected" @change="toggleAll" />
      </div>

      <div slot="checkbox" slot-scope="props">
        <b-form-checkbox
          :checked="table.selected.includes(props.row.id)"
          @change="toggleCell($event, props.row.id)"
        />
      </div>

      <template v-slot:code_hex="props">
        <span>#{{ props.row.code_hex }}</span>
      </template>

      <template v-slot:image="props">
        <img
          style="max-height: 100px; max-width: 100px"
          :src="props.row.image"
        />
      </template>
      <template v-slot:actions="props">
        <b-button
          :to="{
            name: 'AdminStandardEmbroideriesEditScreen',
            params: { id: props.row.id },
          }"
          size="sm"
          variant="outline-primary"
          class="mr-2"
          >Editar</b-button
        >

        <b-button
          @click="removeStandardEmbroidery(props.row.id)"
          size="sm"
          variant="outline-danger"
          class="mr-2"
          >Eliminar</b-button
        >
      </template>
    </v-server-table>
  </div>
</template>

<script>
import { uris, actions } from '@/admin/api.js';

import store from '@/admin/store.js';

export default {
  name: 'StandardEmbroideryList',
  props: {},
  components: {},
  data() {
    return {
      table: {
        url: uris.standardEmbroideriesURI,
        selected: [],
        allSelected: false,
        columns: ['checkbox', 'reference', 'image', 'actions'],
        options: {
          sortable: ['reference'],
          headings: {
            reference: 'Nombre',
            name_es: 'Nombre',
            image: 'Imagen',
            actions: 'Acciones',
          },
        },
      },
      sharedState: store.state,
    };
  },
  created() {},
  methods: {
    removeSelected() {
      this.table.selected.map((x) => {
        this.removeStandardEmbroidery(x);
      });
    },
    removeStandardEmbroidery(id) {
      actions.deleteStandardEmbroidery(id).then((x) => {
        this.$refs.table.refresh();
      });
    },
    toggleCell($event, id) {
      if ($event) {
        this.table.selected.push(id);
      } else {
        this.table.selected = this.table.selected.filter((item) => item !== id);
      }
    },
    toggleAll(checked) {
      this.table.selected = checked
        ? this.$refs.table.data.map((row) => row.id)
        : [];
    },
  },
  mounted() {},
};
</script>

<style scoped></style>
